import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/login/Login'
import Register from '@/components/login/Register'
import EditPassword from '@/components/login/EditPassword'
import ForgetPassword from '@/components/login/ForgetPassword'

import Home from '@/components/Home'

//技术教程
import Tutor from '@/components/Tutor'
import Ptjj from '@/components/tutor/ptjj'
import Zygn_jn from '@/components/tutor/zygn_jn'
import Zygn_yt from '@/components/tutor/zygn_yt'
import Zygn_cw from '@/components/tutor/zygn_cw'
import Zygn_zd from '@/components/tutor/zygn_zd'
import Zygn_dldh from '@/components/tutor/zygn_dldh'


import Zdyjn_ks from '@/components/tutor/zdyjn_ks'
import Zdyjn_nlupro from '@/components/tutor/zdyjn_nlupro'
import Zdyjn_bzqq from '@/components/tutor/zdyjn_bzqq'
import Zdyjn_qqxy from '@/components/tutor/zdyjn_qqxy'
import Zdyjn_bzxy from '@/components/tutor/zdyjn_bzxy'
import Zdyjn_yysc from '@/components/tutor/zdyjn_yysc'
import Zdyjn_ypbf from '@/components/tutor/zdyjn_ypbf'
import Zdyjn_zfdd from '@/components/tutor/zdyjn_zfdd'
import Zdyjn_zfxx from '@/components/tutor/zdyjn_zfxx'
import Zdyjn_zhgl from '@/components/tutor/zdyjn_zhgl'
import Zdyjn_hhsj from '@/components/tutor/zdyjn_hhsj'
import Zdyjn_dldh from '@/components/tutor/zdyjn_dldh'
import Zdyjn_xxl from '@/components/tutor/zdyjn_xxl'
import Zdyjn_jjsj from '@/components/tutor/zdyjn_jjsj'
import Zdyjn_mkf from '@/components/tutor/zdyjn_mkf'
import Zdyjn_zysx from '@/components/tutor/zdyjn_zysx'
import Xggj_tssq from '@/components/tutor/xggj_tssq'
import Xggj_sjgl from '@/components/tutor/xggj_sjgl'
import Jnfb from '@/components/tutor/jnfb'
import Kfzxy from '@/components/tutor/kfzxy'
import FAQ from '@/components/tutor/FAQ'
import License from '@/components/tutor/License'


import Ysnrjn from '@/components/tutor/ysnrjn'
import Znjjjn from '@/components/tutor/znjjjn'

import Yjjrgl from '@/components/tutor/yjjrgl'
import ASDK from '@/components/tutor/ASDK'
import LSDK from '@/components/tutor/LSDK'
import FSDK from '@/components/tutor/FSDK'
import IYYBL from '@/components/tutor/IYYBL'
import AYYBL from '@/components/tutor/AYYBL'

// 智能家居协议文档
import Znjjjnjs from '@/components/tutor/smartHome/Znjjjnjs'
import Zn_jnfblc from '@/components/tutor/smartHome/Zn_jnfblc'
import Zn_sqlc from '@/components/tutor/smartHome/Zn_sqlc'
import Zn_xygs from '@/components/tutor/smartHome/Zn_xygs'
import Zn_sbfx from '@/components/tutor/smartHome/Zn_sbfxqq'
import Zn_sb_dk from '@/components/tutor/smartHome/Zn_sb_dk'
import Zn_sb_duok from '@/components/tutor/smartHome/Zn_sb_duok'
import Zn_sb_wn from '@/components/tutor/smartHome/Zn_sb_wn'
import Zn_sb_qt from '@/components/tutor/smartHome/Zn_sb_qt'
import Zn_sb_payload from '@/components/tutor/smartHome/Zn_sb_payload'

//智能家居协议文档--设备控制
import Zn_sb_dy from '@/components/tutor/smartHome/equipmentControl/Zn_sb_dy'
import Zn_sb_pd from '@/components/tutor/smartHome/equipmentControl/Zn_sb_pd'
import Zn_sb_sy from '@/components/tutor/smartHome/equipmentControl/Zn_sb_sy'
import Zn_sb_bf from '@/components/tutor/smartHome/equipmentControl/Zn_sb_bf'
import Zn_sb_ld from '@/components/tutor/smartHome/equipmentControl/Zn_sb_ld'
import Zn_sb_wd from '@/components/tutor/smartHome/equipmentControl/Zn_sb_wd'
import Zn_sb_sd from '@/components/tutor/smartHome/equipmentControl/Zn_sb_sd'
import Zn_sb_fs from '@/components/tutor/smartHome/equipmentControl/Zn_sb_fs'
import Zn_sb_fx from '@/components/tutor/smartHome/equipmentControl/Zn_sb_fx'
import Zn_sb_ms from '@/components/tutor/smartHome/equipmentControl/Zn_sb_ms'
import Zn_sb_ys from '@/components/tutor/smartHome/equipmentControl/Zn_sb_ys'
import Zn_sb_sw from '@/components/tutor/smartHome/equipmentControl/Zn_sb_sw'
import Zn_sb_xl from '@/components/tutor/smartHome/equipmentControl/Zn_sb_xl'

// 智能家居协议文档-错误信息相应信息
import Zn_err_message from '@/components/tutor/smartHome/errorMessage/Zn_err_message'
// 智能家居协议文档-附录
import Zn_appendix from '@/components/tutor/smartHome/appendix/Zn_appendix'


//个人中心
import Center from '@/components/center'

//技能概览
// import BasicInfo from '@/components/skilloverview/BasicInfo'
import Messages from '@/components/skilloverview/Messages'
import Edition from '@/components/skilloverview/Edition'
import CreateSkill from '@/components/skilloverview/CreateSkill'
import SkillList from '@/components/skilloverview/SkillList'
import UpdateSkill from '@/components/skilloverview/UpdateSkill'
import GeneralizeData from '@/components/skilloverview/GeneralizeData'
import Propelling from '@/components/skilloverview/Propelling'
import PropellingSuc from '@/components/skilloverview/PropellingSuc'

// 欢迎语，结束语配置
import Vocabulary from '@/components/skill/Vocabulary'

// 意图
import CreateIntention from '@/components/skill/intention/CreateIntention'
import IntentionList from '@/components/skill/intention/IntentionList'
import EditIntention from '@/components/skill/intention/EditIntention'
import SystemList from '@/components/skill/intention/SystemList'
import IntentionDeatil from '@/components/skill/intention/IntentionDeatil'

//字典
import CreateDictionaries from '@/components/skill/dictionaries/CreateDictionaries'
import DictionariesList from '@/components/skill/dictionaries/DictionariesList'
import EditDictionaries from '@/components/skill/dictionaries/EditDictionaries'
import SystemDictionariesList from '@/components/skill/dictionaries/SystemDictionariesList'


// 用户
import UserInfo from '@/components/user/UserInfo'

// 其他
import Release from '@/components/setting/Release'
import SettingService from '@/components/setting/SettingService'
import SettingSuc from '@/components/setting/SettingSuc'
import SettingErr from '@/components/setting/SettingErr'
import SettingIng from '@/components/setting/SettingIng'
import Test from '@/components/setting/Test'
import Developer from '@/components/setting/Developer'
import DeveloperSuc from '@/components/setting/DeveloperSuc'
import HomePage from '@/components/setting/HomePage'
import MachineTest from '@/components/setting/MachineTest'

// 智能硬件平台
import Hardhome from '@/components/hardware/Hardhome'
import ProductList from '@/components/hardware/ProductList'
import CreatePro from '@/components/hardware/CreatePro'

import Product from '@/components/hardware/Product'
import ProInfo from '@/components/hardware/pro/ProInfo'
import SDK from '@/components/hardware/pro/SDK'
import SkillInfo from '@/components/hardware/pro/SkillInfo'
import SkillSetting from '@/components/hardware/pro/SkillSetting'
import QA from '@/components/hardware/pro/QA'


// SDK-ios
import Imp_register from '@/components/tutor/SDK-ios/access/Imp_register'
import Agreement from '@/components/tutor/SDK-ios/access/Agreement'
import IosLogin from '@/components/tutor/SDK-ios/access/IosLogin'
import Equipment from '@/components/tutor/SDK-ios/access/Equipment'
import InfoFlow from '@/components/tutor/SDK-ios/access/InfoFlow'
import Use from '@/components/tutor/SDK-ios/access/Use'
import Shop from '@/components/tutor/SDK-ios/access/Shop'
import ThirdParty from '@/components/tutor/SDK-ios/access/ThirdParty'
import Payment from '@/components/tutor/SDK-ios/access/Payment'
import APNS from '@/components/tutor/SDK-ios/access/APNS'
import Parameter from '@/components/tutor/SDK-ios/access/Parameter'
import ErrCode from '@/components/tutor/SDK-ios/access/ErrCode'
import Env from '@/components/tutor/SDK-ios/access/Env'

// SDK-android
import Access from '@/components/tutor/SDK-android/Access'
import Info_flow_a from '@/components/tutor/SDK-android/Info_flow_a'
import Skill_list from '@/components/tutor/SDK-android/Skill_list'
import Skill_detail from '@/components/tutor/SDK-android/Skill_detail'
import X_w from '@/components/tutor/SDK-android/X_w'
import Payment_a from '@/components/tutor/SDK-android/Payment_a'
import Rev_control from '@/components/tutor/SDK-android/Rev_control'
import Theme from '@/components/tutor/SDK-android/Theme'
import Awaken from '@/components/tutor/SDK-android/Awaken'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {path: '/login', name: '登陆', component: Login},
        {path: '/register', name: '注册', component: Register},
        {path: '/editPassword', name: '修改密码', component: EditPassword},
        {path: '/forgetPassword', name: '忘记密码', component: ForgetPassword},
        {path: '/homePage', component: HomePage, name: '首页'},
        {path: '/createSkill', component: CreateSkill, name: '创建技能'},
        // {path: '/tutorial', component: Tutorial, name: '技术教程'},
        // {
        //   path: '/tutorial',
        //   name: 'prohome',
        //   component: Tutorial,
        //   children:[
        //     {path: '/ptjj', component: Ptjj, name: '产品基本信息'},
        //     {path: '/skillSetting', component: SkillSetting, name: '技能配置'},
        //     {path: '/sdk', component: SDK, name: '下载SDK'},
        //     {path: '/sdkTutorial', component: SdkTutorial, name: 'SDK文档教程'},
        //     {path: '/skillInfo', component: SkillInfo, name: '技能详情', meta: {show: true}},
        //   ]
        // },


        {path: '/skillList', component: SkillList, name: '技能列表'},
        {path: '/developer', component: Developer, name: '开发者认证'},
        {path: '/developerSuc', component: DeveloperSuc, name: '开发者认证提示审核页面'},
        // {path: '/userInfo', component: UserInfo, name: '个人信息'},
        // 智能硬件平台
        {path: '/hardhome', component: Hardhome, name: '智能硬件平台'},
        {path: '/productList', component: ProductList, name: '产品列表'},
        {path: '/createPro', component: CreatePro, name: '创建产品'},


        {
            path: '/',
            component: Home,
            children: [
                {path: '/vocabulary', component: Vocabulary, name: '欢迎语/结束语'},
                {path: '/createIntention', component: CreateIntention, name: '创建意图'},
                {path: '/editIntention', component: EditIntention, name: '编辑意图'},
                {path: '/intentionList', component: IntentionList, name: '意图列表'},
                {path: '/systemList', component: SystemList, name: '系统意图列表'},
                {path: '/intentionDeatil', component: IntentionDeatil, name: '意图列表详情'},
                {path: '/createDictionaries', component: CreateDictionaries, name: '创建字典'},
                {path: '/editDictionaries', component: EditDictionaries, name: '编辑字典'},
                {path: '/dictionariesList', component: DictionariesList, name: '字典列表'},
                {path: '/systemDictionariesList', component: SystemDictionariesList, name: '系统字典列表'},
                // {path: '/basicInfo', component: BasicInfo, name: '基本信息'},
                {path: '/generalize', component: GeneralizeData, name: '数据概览'},
                {path: '/propelling', component: Propelling, name: '推送申请'},
                {path: '/propellingSuc', component: PropellingSuc, name: '推送申请成功'},
                {path: '/edition', component: Edition, name: '版本管理'},
                {path: '/updateSkill', component: UpdateSkill, name: '基本信息'},
                {path: '/release', component: Release, name: '发布上线'},
                {path: '/service', component: SettingService, name: '配置服务'},
                {path: '/machineTest', component: MachineTest, name: '真机测试'},
                {path: '/serviceSuc', component: SettingSuc, name: '授权成功'},
                {path: '/serviceErr', component: SettingErr, name: '授权失败'},
                {path: '/serviceIng', component: SettingIng, name: '授权中'},
                {path: '/test', component: Test, name: '线上测试'},
                {path: '/', redirect: '/homePage',}
            ]
        },
        //技术教程
        {
            path: '/tutor',
            component: Tutor,
            children: [
                {path: '/tutor/ptjj', component: Ptjj, name: '平台简介'},
                {path: '/tutor/zygn_jn', component: Zygn_jn, name: '技能'},
                {path: '/tutor/zygn_yt', component: Zygn_yt, name: '意图'},
                {path: '/tutor/zygn_cw', component: Zygn_cw, name: '槽位'},
                {path: '/tutor/zygn_zd', component: Zygn_zd, name: '字典'},
                {path: '/tutor/zygn_dldh', component: Zygn_dldh, name: '多伦对话1'},


                {path: '/tutor/zdyjn_ks', component: Zdyjn_ks, name: '快速创建技能'},
                {path: '/tutor/zdyjn_nlupro', component: Zdyjn_nlupro, name: 'NLU语义协议'},
                {path: '/tutor/zdyjn_qqxy', component: Zdyjn_qqxy, name: '技能请求相应协议'},
                {path: '/tutor/zdyjn_bzqq', component: Zdyjn_bzqq, name: '标准请求'},
                {path: '/tutor/zdyjn_bzxy', component: Zdyjn_bzxy, name: '标准响应'},
                {path: '/tutor/zdyjn_yysc', component: Zdyjn_yysc, name: '语音输出'},
                {path: '/tutor/zdyjn_ypbf', component: Zdyjn_ypbf, name: '音频播放'},
                {path: '/tutor/zdyjn_zfdd', component: Zdyjn_zfdd, name: '支付订单'},
                {path: '/tutor/zdyjn_zfxx', component: Zdyjn_zfxx, name: '支付信息'},
                {path: '/tutor/zdyjn_zhgl', component: Zdyjn_zhgl, name: '账号关联'},
                {path: '/tutor/zdyjn_hhsj', component: Zdyjn_hhsj, name: '会话设计'},
                {path: '/tutor/zdyjn_dldh', component: Zdyjn_dldh, name: '多伦对话'},
                {path: '/tutor/zdyjn_xxl', component: Zdyjn_xxl, name: '信息流'},
                {path: '/tutor/zdyjn_jjsj', component: Zdyjn_jjsj, name: '技能数据'},
                {path: '/tutor/zdyjn_mkf', component: Zdyjn_mkf, name: '麦克风控制'},
                {path: '/tutor/zdyjn_zysx', component: Zdyjn_zysx, name: '注意事项'},
                {path: '/tutor/jnfb', component: Jnfb, name: '技能发布'},
                {path: '/tutor/kfzxy', component: Kfzxy, name: '开发者协议'},
                {path: '/tutor/faq', component: FAQ, name: 'FAQ'},
                {path: '/tutor/license', component: License, name: 'license'},


                {path: '/tutor/ysnrjn', component: Ysnrjn, name: '有声内容技能'},
                {path: '/tutor/znjjjn', component: Znjjjn, name: '智能家居技能'},
                {path: '/tutor/xggj_tssq', component: Xggj_tssq, name: '推送申请1'},
                {path: '/tutor/xggj_sjgl', component: Xggj_sjgl, name: '数据概览1'},
                {path: '/tutor/yjjrgl', component: Yjjrgl, name: '硬件接入攻略'},
                {path: '/tutor/ASDK', component: ASDK, name: '安卓硬件SDK'},
                {path: '/tutor/LSDK', component: LSDK, name: 'linux硬件SDK'},
                {path: '/tutor/FSDK', component: FSDK, name: 'FreeRTOS硬件SDK '},
                {path: '/tutor/IYYBL', component: IYYBL, name: '语音伴侣IOS '},
                {path: '/tutor/AYYBL', component: AYYBL, name: '语音伴侣Android '},


                {path: '/tutor/znjjjnjs', component: Znjjjnjs, name: '智能家居技能介绍'},
                {path: '/tutor/zn_jnfblc', component: Zn_jnfblc, name: '智能家居技能发布流程'},
                {path: '/tutor/zn_sqlc', component: Zn_sqlc, name: '智能家居授权流程介绍'},
                {path: '/tutor/zn_xygs', component: Zn_xygs, name: '协议概述'},
                {path: '/tutor/zn_sbfx', component: Zn_sbfx, name: '设备发现'},
                {path: '/tutor/zn_sb_dk', component: Zn_sb_dk, name: '单孔插座'},
                {path: '/tutor/zn_sb_duok', component: Zn_sb_duok, name: '多孔插座'},
                {path: '/tutor/zn_sb_wn', component: Zn_sb_wn, name: '万能遥控器'},
                {path: '/tutor/zn_sb_qt', component: Zn_sb_qt, name: '其他品类'},
                {path: '/tutor/zn_sb_payload', component: Zn_sb_payload, name: 'payload'},

                //智能家居--设备控制
                {path: '/tutor/zn_sb_dy', component: Zn_sb_dy, name: '电源类操作'},
                {path: '/tutor/zn_sb_pd', component: Zn_sb_pd, name: '电源类操作'},
                {path: '/tutor/zn_sb_sy', component: Zn_sb_sy, name: '声音类的控制'},
                {path: '/tutor/zn_sb_bf', component: Zn_sb_bf, name: '播放类的控制'},
                {path: '/tutor/zn_sb_ld', component: Zn_sb_ld, name: '亮度的控制'},
                {path: '/tutor/zn_sb_wd', component: Zn_sb_wd, name: '温度的控制'},
                {path: '/tutor/zn_sb_sd', component: Zn_sb_sd, name: '湿度的控制'},
                {path: '/tutor/zn_sb_fs', component: Zn_sb_fs, name: '风速的控制'},
                {path: '/tutor/zn_sb_fx', component: Zn_sb_fx, name: '风向的控制'},
                {path: '/tutor/zn_sb_ms', component: Zn_sb_ms, name: '模式的控制'},
                {path: '/tutor/zn_sb_ys', component: Zn_sb_ys, name: '颜色的设置'},
                {path: '/tutor/zn_sb_sw', component: Zn_sb_sw, name: '水位的设置'},
                {path: '/tutor/zn_sb_xl', component: Zn_sb_xl, name: '水位的设置'},


                // 智能家居协议文档-错误信息相应信息
                {path: '/tutor/zn_err_message', component: Zn_err_message, name: '错误信息'},


                // 智能家居协议文档-附录
                {path: '/tutor/zn_appendix', component: Zn_appendix, name: '附录'},

                // SDK-ios
                {path: '/tutor/imp_register', component: Imp_register, name: '导入及注册'},
                {path: '/tutor/agreement', component: Agreement, name: '导入及注册'},
                {path: '/tutor/ios_login', component: IosLogin, name: 'ios登录'},
                {path: '/tutor/equipment', component: Equipment, name: '设备管理'},
                {path: '/tutor/info', component: InfoFlow, name: '信息流'},
                {path: '/tutor/use', component: Use, name: 'OVSMediaCodec使用'},
                {path: '/tutor/shop', component: Shop, name: '技能商店'},
                {path: '/tutor/thirdParty', component: ThirdParty, name: '第三方服务'},
                {path: '/tutor/payment', component: Payment, name: '支付服务'},
                {path: '/tutor/apns', component: APNS, name: 'APNS使用'},
                {path: '/tutor/parameter', component: Parameter, name: '返回参数说明'},
                {path: '/tutor/errcode', component: ErrCode, name: '错误码'},

                // SDK-android
                {path: '/tutor/access', component: Access, name: '接入帮助'},
                {path: '/tutor/info_flow_a', component: Info_flow_a, name: '信息流'},
                {path: '/tutor/s_list', component: Skill_list, name: '技能列表'},
                {path: '/tutor/s_detail', component: Skill_detail, name: '技能详情'},
                {path: '/tutor/x_w', component: X_w, name: '小微登录接入'},
                {path: '/tutor/payment_a', component: Payment_a, name: '支付接入'},
                {path: '/tutor/rev_c', component: Rev_control, name: '反向控制'},
                {path: '/tutor/theme', component: Theme, name: '自定义主题'},
                {path: '/tutor/awaken', component: Awaken, name: '唤起码'},
                {path: '/tutor/env', component: Env, name: '环境及组件介绍'},


            ]
        },

        {
            path: '/product',
            component: Product,
            children: [
                {path: '/proInfo', component: ProInfo, name: '产品基本信息'},
                {path: '/skillSetting', component: SkillSetting, name: '技能配置'},
                {path: '/qa', component: QA, name: '问答库'},
                {path: '/sdk', component: SDK, name: '下载SDK'},
                {path: '/skillInfo', component: SkillInfo, name: '技能详情', meta: {show: true}},
            ]
        },
        //个人中心
        {
            path: '/center',
            name: 'center',
            component: Center,
            children: [
                {path: 'center-people', component: UserInfo, name: '个人信息'},
                {path: 'messages', component: Messages, name: '消息'}
            ]
        },
        {
            path: '*',
            redirect: '/login',
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js